<div class="bitcoin-app investments-popup"
     [class.has-footer]="showFooter()"
     [class.is-active]="activeClass">
  <div class="bitcoin-app__inner investments-popup__inner">
    <button class="investments-popup__close"
            (click)="handleClose()"></button>
    <iframe [src]="safeUrl" allow="clipboard-write *; clipboard-read *"></iframe>

    <div class="bitcoin-app__paypal"
         *ngIf="showFooter()">
      <div class="paypal-footer">
        <div class="paypal-footer__wrapper">
          <button class="paypal-footer__btn"
                  [ngStyle]="{'visibility': contentLoaded ? 'visible' : 'hidden'}"
                  [disabled]="appIsOpening"
                  (click)="openPaypal()">
            <ng-container *ngIf="appIsOpening; else openApp">
              <ng-container *ngIf="isPaypalIframe()">
                {{ 'paypalPopup' | languageTranslate: [{$innerVariable: 'openingBtn'}]  }}
              </ng-container>
              <ng-container *ngIf="isCashAppUSDCIframe()">
                {{ 'cashAppPopup' | languageTranslate: [{$innerVariable: 'openingBtn'}]  }}
              </ng-container>
            </ng-container>
            <ng-template #openApp>
              <ng-container *ngIf="isPaypalIframe()">
                {{ 'paypalPopup' | languageTranslate: [{$innerVariable: 'openBtn'}]  }}
              </ng-container>
              <ng-container *ngIf="isCashAppUSDCIframe()">
                {{ 'cashAppPopup' | languageTranslate: [{$innerVariable: 'openBtn'}]  }}
              </ng-container>
            </ng-template>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
